import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from '../../common/loadingComponent';
import { writeErr } from '../../common/logger';
import { popupActions } from '../../../store/popupStore';
import { domainActions } from '../../../store/domainStore';
import { isNullOrUndefined, validateInput } from '../../../store/storeFunctions';
import { apiGet, apiPost, getHostApi, parseQuery } from '../../../store/apiWrapper';
import BbFormikCheckbox from '../../styling/bbFormikCheckbox';
import BbCheckbox from "../../styling/bbCheckbox";
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import SelectOption from '../../searchSections/selectOption';
import BbInput from '../../styling/bbInput';
import { PORTFOLIO_TYPES } from '../../monitoring/monitoringConstants';

import './conflictOfInterest.scss';

const SK = "SK";
const CZ = "CZ";
const DOMAIN_REL_TYPES = 'coi-rel-types';

const SOURCE_TYPES_KEYS = {
    single: "single",
    list: "list",
    portfolio: "portfolio"
};

const SOURCE_TYPES = [
    { name: SOURCE_TYPES_KEYS.single, trKey: "ConflictOfInterest.CheckList.SubjectsToCheck.SingleCompanyId" },
    { name: SOURCE_TYPES_KEYS.list, trKey: "ConflictOfInterest.CheckList.SubjectsToCheck.List" },
    { name: SOURCE_TYPES_KEYS.portfolio, trKey: "ConflictOfInterest.CheckList.SubjectsToCheck.Portfolio" }
];

const TIME_SPECS = {
    actualOnly: "actualOnly",
    includeHistory: "includeHistory",
    timeRange: "timeRange"
};

const KEYS = {
    clientList: "clientList",
    clientSpecification: "clientSpecification",
    companyId: "companyId",
    registrationCountry: "registrationCountry",
    referenceList: "referenceList",
    timeSpecification: "timeSpecification",
    historyFrom: "historyFrom",
    historyTo: "historyTo",
    timeRange: "timeRange",
    relDepth: "relDepth",
    relTypes: "relTypes"
};

class ConflictOfInterestCheckListForm extends React.Component {
    mounted = false;

    state = {
        selectedClientListCount: null,
        selectedReferenceListCount: null,
        referenceListCount: null,
        clientListCount: null,
        portfolios: null,
        submitting: false,
        loadingPortfolios: false,
        loadingReferenceList: false,
        loadingClientList: false
    };

    render() {
        if (this.isLoading(DOMAIN_REL_TYPES))
            return <Circles />

        const checkListItems = this.getCheckListItems();
        const referenceListItems = this.getReferenceListItems();
        const registrationCountries = this.getRegistrationCountries();
        const checkListPortfolio = this.getPortfolioId();

        return (
            <div className='columns is-centered is-multiline'>
                <div className="column is-12">
                    <Formik
                        ref={(el) => this.formRef = el}
                        enableReinitialize={true}
                        validateOnChange={false}
                        validateOnBlur={false}
                        initialValues={{
                            [KEYS.clientList]: isNullOrUndefined(checkListPortfolio) ? "" : `${SOURCE_TYPES_KEYS.portfolio}_${checkListPortfolio}`,
                            [KEYS.clientSpecification]: isNullOrUndefined(checkListPortfolio) ? SOURCE_TYPES_KEYS.single : SOURCE_TYPES_KEYS.portfolio,
                            [KEYS.companyId]: "",
                            [KEYS.registrationCountry]: this.props.userProfile.agentLanguage === 'sk-SK' ? SK : CZ,
                            [KEYS.referenceList]: SOURCE_TYPES_KEYS.list,
                            [KEYS.timeSpecification]: TIME_SPECS.actualOnly,
                            [KEYS.historyFrom]: "",
                            [KEYS.historyTo]: "",
                            [KEYS.timeRange]: 1,
                            [KEYS.relDepth]: 1,
                            [KEYS.relTypes]: {
                                "NR03": true,
                                "NR02": true,
                                "NRSS": false,
                                "NR01": true,
                                "NRZS": true,
                                "NRBO": false,
                                "NR0G": true,
                                "NR09": true,
                                "NRSA": false,
                                "NR08": false,
                                "NR0K": false,
                                "NR0H": false,
                                "NRPV": true,
                                "NRNA": false,
                            }
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(false);
                            this.onSubmit(values);
                        }}>
                        {({ values, setFieldValue }) => (
                            <Form>
                                <div className="columns">
                                    <div className="bb-radio-group-wrapper">
                                        <div className="bb-radio-group-row">
                                            {SOURCE_TYPES.map((i, j) =>
                                                <div className="control">
                                                    <BbRadioWrapper
                                                        id={`$radio-${i.name}`}
                                                        name={i.name}
                                                        value={i.name}
                                                        checked={values[KEYS.clientSpecification] === i.name}
                                                        callback={(e) => this.onClientSpecificationChanged(i, setFieldValue)}
                                                        label={this.props.translate(i.trKey)}
                                                    />
                                                </div>)}
                                        </div>
                                    </div>
                                </div>

                                {values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.single && <>
                                    <BbInput name={KEYS.companyId} type="text" label={this.props.translate("ConflictOfInterest.CheckList.CompanyId")}
                                        placeholder={{ type: "column" }} />
                                    <BbInput type="select-noformik" label={this.props.translate("ConflictOfInterest.CheckList.RegistrationCountry")}
                                        placeholder={{ type: "column" }}
                                        options={registrationCountries}
                                        formatOptionLabel={SelectOption}
                                        value={registrationCountries.find(f => f.value === values[KEYS.registrationCountry])}
                                        onChange={(e) => setFieldValue(KEYS.registrationCountry, e.value)}
                                    />
                                </>}

                                {(values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.portfolio) && <div>
                                    <BbInput type="select-noformik" label={this.props.translate("ConflictOfInterest.CheckList.SubjectsToCheck")}
                                        placeholder={{ type: "column" }}
                                        options={checkListItems}
                                        formatOptionLabel={SelectOption}
                                        value={checkListItems.find(f => f.value === values[KEYS.clientList])}
                                        onChange={(e) => this.onClientListItemChanged(e, setFieldValue)}
                                    />
                                </div>}

                                {(values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.list || values[KEYS.clientSpecification].startsWith(SOURCE_TYPES_KEYS.portfolio)) &&
                                    this.renderListSubjectCount(KEYS.clientList, "ConflictOfInterest.CheckList.VerifiedSubjectsInListCount",
                                        !values[KEYS.clientSpecification].startsWith(SOURCE_TYPES_KEYS.portfolio))
                                }

                                <div>
                                    <BbInput type="select-noformik" label={this.props.translate("ConflictOfInterest.CheckList.ReferenceList")}
                                        placeholder={{ type: "column" }}
                                        options={referenceListItems}
                                        formatOptionLabel={SelectOption}
                                        value={referenceListItems.find(f => f.value === values[KEYS.referenceList])}
                                        onChange={(e) => this.onReferecneListItemChanged(e, setFieldValue)}
                                    />
                                </div>

                                {this.renderListSubjectCount(KEYS.referenceList)}

                                {this.renderParamForm(values, setFieldValue)}

                                <div style={{ display: "flex", justifyContent: "center", marginTop: "2.5em" }}>
                                    <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                        type='submit' style={{ fontWeight: 600 }}
                                        disabled={(values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.single && values[KEYS.companyId] === "") ||
                                            (values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.portfolio && values[KEYS.clientList] === "")}
                                    >
                                        {this.isBusy() ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='ConflictOfInterest.CheckList.Check' />}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.mounted = true;
        this.props.ensureDomainData(DOMAIN_REL_TYPES);
        this.getPortfolioList();
        this.getReferenceListCount();
        this.getClientListCount();
    }

    componentDidUpdate() {
        if (this.mounted) {
            if (!this.hasDomainData(DOMAIN_REL_TYPES))
                this.props.ensureDomainData(DOMAIN_REL_TYPES);
            if (isNullOrUndefined(this.state.portfolios) && !this.state.loadingPortfolios)
                this.getPortfolioList();
            if (isNullOrUndefined(this.state.clientListCount) && !this.state.loadingClientList)
                this.getClientListCount();
            if (isNullOrUndefined(this.state.referenceListCount) && !this.state.loadingReferenceList)
                this.getReferenceListCount();
        }
    }

    renderListSubjectCount = (listType, trKey = null, singleColumn = false) => {
        return (
            <div className="columns">
                {!singleColumn && <div className="column is-one-third" />}
                <div className={classnames("column", { "is-two-thirds": !singleColumn })}>
                    <Translate id={isNullOrUndefined(trKey) ? "ConflictOfInterest.CheckList.SubjectsInListCount" : trKey} />
                    <>: </>
                    <span>{listType === KEYS.clientList ? this.state.selectedClientListCount : KEYS.referenceList ? this.state.selectedReferenceListCount : "-"}</span>
                </div>
            </div>
        );
    }

    renderParamForm = (values, setFieldValue) => {
        const timeRanges = this.getTimeRanges();
        const relDepths = this.getRelationDepths();

        return (
            <>
                <hr />
                <h2 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "1em" }}>
                    <Translate id="ConflictOfInterest.CheckList.DefinitionOfParameters" />
                </h2>
                <div className="columns">
                    <div className="bb-radio-group-wrapper">
                        <div className="bb-radio-group-row">
                            <div className="control">
                                <BbRadioWrapper
                                    id="radio-tmspec-actual-only"
                                    name={TIME_SPECS.actualOnly}
                                    value={TIME_SPECS.actualOnly}
                                    checked={values[KEYS.timeSpecification] === TIME_SPECS.actualOnly}
                                    callback={(e) => setFieldValue(KEYS.timeSpecification, TIME_SPECS.actualOnly)}
                                    label={this.props.translate("ConflictOfInterest.CheckList.Relations.ActualOnly")}
                                />
                            </div>
                            <div className="control">
                                <BbRadioWrapper
                                    id="radio-tmspec-include-history"
                                    name={TIME_SPECS.includeHistory}
                                    value={TIME_SPECS.includeHistory}
                                    checked={values[KEYS.timeSpecification] === TIME_SPECS.includeHistory}
                                    callback={(_) => setFieldValue(KEYS.timeSpecification, TIME_SPECS.includeHistory)}
                                    label={this.props.translate("ConflictOfInterest.CheckList.Relations.IncludingHistory")}
                                />
                            </div>
                            <div className="control">
                                <BbRadioWrapper
                                    id="radio-tmspec-time-range"
                                    name={TIME_SPECS.timeRange}
                                    value={TIME_SPECS.timeRange}
                                    checked={values[KEYS.timeSpecification] === TIME_SPECS.timeRange}
                                    callback={(_) => setFieldValue(KEYS.timeSpecification, TIME_SPECS.timeRange)}
                                    label={this.props.translate("ConflictOfInterest.CheckList.Relations.TimeRange")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='field bb-field'>
                    <div className="columns">
                        <div className="column is-4 bb-input-label-column">
                            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Translate id="ConflictOfInterest.CheckList.HistoryRange" />
                            </div>
                        </div>
                        <div className="column is-4">
                            <Field type="text" name={KEYS.historyFrom} placeholder={this.props.translate("ConflictOfInterest.CheckList.HistoryRange.From")}
                                className="input form-control" value={values[KEYS.historyFrom]}
                                onChange={(e) => {
                                    const v = isNullOrUndefined(e.target) ? null : e.target.value;
                                    if (!isNullOrUndefined(v) && v.match(/^\d*$/))
                                        setFieldValue(KEYS.historyFrom, v);
                                }}
                                onInput={(e) => validateInput(e)}
                            />
                        </div>
                        <div className="column is-4">
                            <Field type="text" name={KEYS.historyTo} placeholder={this.props.translate("ConflictOfInterest.CheckList.HistoryRange.To")}
                                className="input form-control" value={values[KEYS.historyTo]}
                                onChange={(e) => {
                                    const v = isNullOrUndefined(e.target) ? null : e.target.value;
                                    if (!isNullOrUndefined(v) && v.match(/^\d*$/))
                                        setFieldValue(KEYS.historyTo, v);
                                }}
                                onInput={(e) => validateInput(e)}
                            />
                        </div>
                    </div>
                </div>
                <BbInput type="select-noformik" label={this.props.translate("ConflictOfInterest.CheckList.TimeRangeAmount")}
                    placeholder={{ type: "column" }}
                    options={timeRanges}
                    formatOptionLabel={SelectOption}
                    value={timeRanges.find(f => f.value === values[KEYS.timeRange])}
                    onChange={(e) => setFieldValue(KEYS.timeRange, e.value)}
                />
                <BbInput type="select-noformik" label={this.props.translate("ConflictOfInterest.CheckList.RelationsDepth")}
                    placeholder={{ type: "column" }}
                    options={relDepths}
                    formatOptionLabel={SelectOption}
                    value={relDepths.find(f => f.value === values[KEYS.relDepth])}
                    onChange={(e) => setFieldValue(KEYS.relDepth, e.value)}
                />
                <div className='field bb-field'>
                    <div className="columns is-multiline">
                        <div className="column is-4 bb-input-label-column">
                            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Translate id="ConflictOfInterest.CheckList.RelationTypes" />
                            </div>
                        </div>
                        <div className="column is-8" style={{ paddingBottom: 0 }}>
                            <div className="bb-chk-grp-all">
                                <BbCheckbox
                                    label={this.props.translate("Charts.CheckAll")}
                                    name={`${KEYS.relTypes}.all`}
                                    id="rt-all"
                                    value={this.isAllChecked(values)}
                                    onChange={(c) => this.checkAll(values, c, setFieldValue)} />
                            </div>
                        </div>
                        {this.getRelationTypeCheckBoxes(values, setFieldValue).map(x => x)}
                    </div>
                </div>
            </>
        )
    }

    getRelationTypeCheckBoxes = (values, setFieldValue) => {
        const items = [];
        const relTypes = Object.keys(values[KEYS.relTypes]);

        for (var i = 0; i < relTypes.length; i++) {
            items.push(<div className="column is-4" />);
            items.push(<div className="column is-4 coi-checkbox">{this.renderRelationTypeCheckBox(relTypes[i++], values, setFieldValue)}</div>)
            if (i < relTypes.length)
                items.push(<div className="column is-4 coi-checkbox">{this.renderRelationTypeCheckBox(relTypes[i], values, setFieldValue)}</div>)
            else
                items.push(<div className="column is-4" />);
        }

        return items;
    }

    renderRelationTypeCheckBox = (code, values, setFieldValue) => {
        const data = this.getRelationTypeDomainData(code);
        const id = `rt-${code}`;

        return (
            <BbFormikCheckbox
                label={isNullOrUndefined(data) ? "-" : data.label}
                name={`${KEYS.relTypes}.${code}`}
                id={id}
            />
        );
    }

    isAllChecked = (values) => {
        let checkedCount = Object.keys(values[KEYS.relTypes]).filter(f => values[KEYS.relTypes][f] === true).length;
        let allCount = Object.keys(values[KEYS.relTypes]).length;
        if (checkedCount === 0) { return false };
        if (checkedCount === allCount) { return true };
        return null;
    }

    checkAll = (values, value, setFieldValue) => {
        let newState = Object.assign({}, values[KEYS.relTypes]);
        Object.keys(newState).map((c) => {
            newState[c] = value;
        });
        setFieldValue(KEYS.relTypes, newState);
    }


    onClientSpecificationChanged = (item, setFieldValue) => {
        setFieldValue(KEYS.clientSpecification, item.name);

        setFieldValue(KEYS.companyId, "");
        if (item.name === SOURCE_TYPES_KEYS.list)
            this.setState({ selectedClientListCount: this.state.clientListCount });
        else
            this.setState({ selectedClientListCount: null });
    }

    onClientListItemChanged = (item, setFieldValue) => {
        setFieldValue(KEYS.clientList, item.value);

        if (item.value.startsWith(SOURCE_TYPES_KEYS.portfolio)) {
            const p = this.state.portfolios.find(f => f.portfolioId === item.key);
            const c = isNullOrUndefined(p) ? 0 : p.subjectCount
            this.setState({ selectedClientListCount: c });
        }
        else
            this.setState({ selectedClientListCount: null });
    }

    onReferecneListItemChanged = (item, setFieldValue) => {
        setFieldValue(KEYS.referenceList, item.value);
        if (item.value === SOURCE_TYPES_KEYS.list) {
            this.setState({ selectedReferenceListCount: this.state.referenceListCount });
        }
        else if (item.value.startsWith(SOURCE_TYPES_KEYS.portfolio)) {
            const p = this.state.portfolios.find(f => f.portfolioId === item.key);
            const c = isNullOrUndefined(p) ? 0 : p.subjectCount
            this.setState({ selectedReferenceListCount: c });
        }
        else
            this.setState({ selectedReferenceListCount: null });
    }

    onSubmit = (values) => {
        this.setState({ submitting: true });
        if (values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.single) {
            apiGet(`${getHostApi()}/api/conflict-of-interest/check-subject?ico=${values[KEYS.companyId].replace(/\s/g, '')}&country=${values[KEYS.registrationCountry]}`, {},
                (r) => this.checkSubjectConfirm(r.data, values),
                (e) => {
                    writeErr(e);
                    this.setState({ submitting: false });
                }
            );
        }
        else
            this.checkRelations(null, values);
    }

    checkSubjectConfirm = (subjectData, formData) => {
        this.props.showPopup('confirmationPopup', {
            title: this.props.translate('ConflictOfInterest.CheckList.CheckSubjectPopupTitle'),
            htmlBody: !subjectData.found
                ? this.props.translate("ConflictOfInterest.CheckPopup.SubjectNotFound")
                : `<p>${this.props.translate("Alerts.Subject")}: <b>${subjectData.ico}, ${subjectData.name}</b></p><br/>
                    <p>${this.props.translate("ConflictOfInterest.CheckList.CheckSubjectPopupBody")}</p>`,
            yesButtonText: this.props.translate("ConflictOfInterest.CheckList.Check"),
            yesButtonDisabled: !subjectData.found,
            yesButtonFunction: () => {
                this.props.hidePopup();
                if (subjectData.found)
                    this.checkRelations(subjectData.entityId, formData);
            },
            noButtonText: this.props.translate('Common.Button.Cancel'),
            open: true,
            close: () => this.props.hidePopup()
        });
    }

    checkRelations = (entityId, values) => {
        const query = {
            level: values[KEYS.relDepth],
            relationGroups: Object.keys(values[KEYS.relTypes]).filter(f => values[KEYS.relTypes][f] === true).join("|")
        };

        if (values[KEYS.timeSpecification] === TIME_SPECS.includeHistory) {
            query.historical = true;
            if (!isNullOrUndefined(values[KEYS.historyFrom]) && values[KEYS.historyFrom] !== "")
                query.historicalYearFrom = values[KEYS.historyFrom];
            if (!isNullOrUndefined(values[KEYS.historyTo]) && values[KEYS.historyTo] !== "")
                query.historicalYearTo = values[KEYS.historyTo];
        } else if (values[KEYS.timeSpecification] === TIME_SPECS.timeRange)
            query.timeRange = values[KEYS.timeRange]

        if (values[KEYS.clientSpecification] === SOURCE_TYPES_KEYS.single)
            query.entityId = entityId;
        else if (values[KEYS.clientList].startsWith(SOURCE_TYPES_KEYS.portfolio))
            query.clientListPortfolioId = values[KEYS.clientList].replace(`${SOURCE_TYPES_KEYS.portfolio}_`, "");

        if (values[KEYS.referenceList].startsWith(SOURCE_TYPES_KEYS.portfolio))
            query.referenceListPortfolioId = values[KEYS.referenceList].replace(`${SOURCE_TYPES_KEYS.portfolio}_`, "");

        const queryString = Object.keys(query).map(k => `${k}=${encodeURIComponent(query[k])}`).join("&");
        this.setState({ submitting: false });
        this.props.history.push(`/search/conflictOfInterest/result?${queryString}`)
    }

    getPortfolioList = () => {
        this.setState({ loadingPortfolios: true });
        apiPost(`${getHostApi()}/api/conflict-of-interest/portfolio-list`, null, {},
            (r) => {
                this.setState({
                    portfolios: r.data,
                    loadingPortfolios: false
                });
            },
            (e) => {
                writeErr(e);
                this.setState({ loadingPortfolios: false });
            }
        );
    }

    getReferenceListCount = () => {
        this.setState({ loadingReferenceList: true });
        apiGet(`${getHostApi()}/api/conflict-of-interest/reference/list`, {},
            (r) => {
                const newState = {
                    referenceListCount: r.data.total,
                    loadingReferenceList: false,
                };
                if (this.state.selectedReferenceListCount === null)
                    newState.selectedReferenceListCount = r.data.total;
                this.setState(newState);
            },
            (e) => {
                writeErr(e);
                this.setState({ loadingReferenceList: false });
            }
        );
    }

    getClientListCount = () => {
        this.setState({ loadingClientList: true });
        apiGet(`${getHostApi()}/api/conflict-of-interest/client/list`, {},
            (r) => {
                this.setState({
                    clientListCount: r.data.total,
                    loadingClientList: false
                });
            },
            (e) => {
                writeErr(e);
                this.setState({ loadingClientList: false });
            }
        );
    }

    getCheckListItems = () => [
        ...this.getPortfolioLabels()
    ];

    getReferenceListItems = () => [
        { key: 1, value: SOURCE_TYPES_KEYS.list, label: this.props.translate("ConflictOfInterest.CheckList.ReferenceList") },
        ...this.getPortfolioLabels()
    ];

    getPortfolioLabels = () => {
        if (isNullOrUndefined(this.state.portfolios) || this.state.portfolios.length === 0)
            return [];

        return [...this.state.portfolios].map(p => ({
            key: p.portfolioId,
            value: `${SOURCE_TYPES_KEYS.portfolio}_${p.portfolioId}`,
            label: this.getPortfolioName(p.name, p.type, p.isFirstLevel)
        }));
    }

    getPortfolioName = (name, type, isFirstLevel) => {
        const result = isFirstLevel ? `${name} (${this.props.translate("ConflictOfInterest.CheckList.Portfolio1")} - #X#)` : `${name} (#X#)`

        if (![PORTFOLIO_TYPES.companyCz, PORTFOLIO_TYPES.personCz, PORTFOLIO_TYPES.companySk, PORTFOLIO_TYPES.personSk].includes(type))
            return result.replace("#X#", "?");

        const country = type === PORTFOLIO_TYPES.companyCz || type === PORTFOLIO_TYPES.personCz ? "CZ" : "SK";
        const trKey = `ConflictOfInterest.CheckList.Portfolio1.${(type === PORTFOLIO_TYPES.companyCz || type === PORTFOLIO_TYPES.companySk ? "PO" : "FO")}`;

        return result.replace("#X#", `${this.props.translate(trKey)} ${country}`);
    }

    getTimeRanges = () => {
        const label = this.props.translate("ConflictOfInterest.CheckList.TimeRangeAmount.Value");
        return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(k => { return { key: k + 1, value: k + 1, label: label.replace("{amount}", `${k + 1}`) } });
    }

    getPortfolioId() {
        return isNullOrUndefined(this.props.location.search) ? null : parseQuery(this.props.location.search).portfolioId;
    }

    getRelationTypeDomainData = (code) => this.hasDomainData(DOMAIN_REL_TYPES) ? this.props.domain[DOMAIN_REL_TYPES].requestResult.find(f => f.value === code) : null;
    getRegistrationCountries = () => [{ key: CZ, value: CZ, label: CZ }, { key: SK, value: SK, label: SK }];
    getRelationDepths = () => [{ key: 1, value: 1, label: "1" }, { key: 2, value: 2, label: "2" }];
    hasDomainData = (key) => !(isNullOrUndefined(this.props.domain[key]) || (isNullOrUndefined(this.props.domain[key].requestResult) || this.props.domain[key].isRequesting));
    isLoading = (key) => !isNullOrUndefined(this.props.domain[key]) && this.props.domain[key].isRequesting;
    isBusy = () => this.state.loadingClientList || this.state.loadingClientList || this.state.loadingReferenceList || this.state.submitting;
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, domain: state.domain, userProfile: state.userContext.authentication.profile }),
    dispatch => bindActionCreators({ ...domainActions, ...popupActions }, dispatch),
)(ConflictOfInterestCheckListForm)));
